import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import BreachEvents from './pages/BreachEvents'
import MonitoredAccounts from './pages/MonitoredAccounts'
import AccountLockout from './pages/AccountLockout'
import RiskTrends from './pages/RiskTrends'
import Settings from './pages/Settings'

const AppRouter = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/breach-events" element={<BreachEvents />} />
        <Route path="/monitored-accounts" element={<MonitoredAccounts />} />
        <Route path="/account-lockout" element={<AccountLockout />} />
        <Route path="/risk-trends" element={<RiskTrends />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-4xl font-bold text-text-primary mb-4">404</h1>
      <p className="text-text-muted">Page not found</p>
    </div>
  )
}

export default AppRouter
